

import Navbar from "../Nav";
export default function Header() { 
	return (
	  <header class="full-screen-element">
		<Navbar />
	  </header>
	);
  }